import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/Login'
import axios from "axios";
import {baseUrl} from "@/utils/base";
import HomeView from '../views/HomeView.vue'
import MineView from '../views/MineView.vue'
import PrivacyView from '../views/PrivacyView.vue'
import MonitorView from '../views/MonitorView.vue'
import MonitorInfoView from '../views/MonitorInfoView.vue'
import MapView from '../views/map.vue'
import MonitorDetailView from '../views/MonitorDetailView'
import ScreenControlView from '../views/ScreenControlView'
import MediaDetailView from '../views/MediaDetailView'
import SingleMonitorView from '../views/SingleMonitorView'



Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: LoginView
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/home', // 画面监播
        name: 'home',
        component: HomeView
    },
    {
        path: '/monitorDetail', // 画面监播详情
        name: 'monitorDetail',
        component: MonitorDetailView
    },
    {
        path: '/mine', // 我的页面路由
        name: 'mine',
        component: MineView
    },
    {
        path: '/privacy', // 隐私条款
        name: 'privacy',
        component: PrivacyView
    },
    {
        path: '/monitor', // 监测数据
        name: 'monitor',
        component: MonitorView
    },
    {
        path: '/monitorInfo', //监测数据详情
        name: 'monitorInfo',
        component: MonitorInfoView
    },
    {
        path: '/map', //监测数据地图
        name: 'map',
        component: MapView
    },
    {
        path: '/screenControl', // 屏体管控
        name: 'screenControl',
        component: ScreenControlView
    },
    {
        path: '/mediaDetail', // 媒体详情
        name: 'mediaDetail',
        component: MediaDetailView
    },
    {
        path: '/singleMonitor', // 单屏监播
        name: 'singleMonitor',
        component: SingleMonitorView
    },
    {
        path: '/inspection', // 巡查列表
        name: 'inspection',
        component: () => import('../views/InspectionView.vue')
    },
    {
        path: '/inspectionEdit', // 巡查新增/编辑
        name: 'inspectionEdit',
        component: () => import('../views/InspectionEditView.vue')
    },
    {
        path: '/inspectionDetail', // 巡查详情
        name: 'inspectionDetail',
        component: () => import('../views/InspectionDetailView.vue')
    }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 使用全局前置守卫来判断是否统一登录
router.beforeEach(async (to, from, next) => {


    // 简化条件判断：空字符串/null 直接为 false
    if (window.location.pathname === '/' && window.location.search) {
        console.log("22222222",window.location)
       const a = window.location.search.split("=")[0];
        const b = window.location.search.split("=")[1];
        try {
            // 科信入场请求（用 await 等待请求完成）

            if (a == "?ticket") {
                const res = await axios({
                    url: `${baseUrl}/login/h5CallbackAddress${window.location.search}`,
                    method: "get",
                });
                console.log("res",res.data)
                if (+res.data.rescode === 200) {
                    window.sessionStorage.setItem('token', res.data.data);
                    // 关键：通过 Vue 全局实例访问 $message（前提是你已全局注册了 message 组件）
                    Vue.prototype.$message({
                        message: '登录成功',
                        type: 'success',
                        duration: 2000
                    });
                    window.sessionStorage.setItem('token', res.data.data.token);
                    window.sessionStorage.setItem('userCode', res.data.data.user.userCode);
                    console.log("res.data.data.user",res.data.data.user)
                    window.sessionStorage.setItem('userInfo', JSON.stringify( res.data.data.user));

                    // 关键：清除URL的search参数，再跳转（避免刷新后再次触发）
                    window.history.replaceState({}, document.title, window.location.pathname);
                    // 直接使用 router 实例跳转，而非 this.$router
                    next('/monitor'); // 用 next 跳转，不要用 router.push
                } else {

                    Vue.prototype.$message({
                        message: res.data.msg,
                        type: 'error',
                        duration: 2000
                    });
                    next(); // 登录失败，继续走原路由逻辑
                }
            }else {
                const res = await axios({
                    url: `${baseUrl}/login/h5CallbackAddress?ticket=${b}`,
                    method: "get",
                });
                console.log("res",res.data)
                if (+res.data.rescode === 200) {
                    window.sessionStorage.setItem('token', res.data.data);
                    // 关键：通过 Vue 全局实例访问 $message（前提是你已全局注册了 message 组件）
                    Vue.prototype.$message({
                        message: '登录成功',
                        type: 'success',
                        duration: 2000
                    });
                    window.sessionStorage.setItem('token', res.data.data.token);
                    window.sessionStorage.setItem('userCode', res.data.data.user.userCode);
                    console.log("res.data.data.user",res.data.data.user)
                    window.sessionStorage.setItem('userInfo', JSON.stringify( res.data.data.user));

                    // 关键：清除URL的search参数，再跳转（避免刷新后再次触发）
                    window.history.replaceState({}, document.title, window.location.pathname);
                    // 直接使用 router 实例跳转，而非 this.$router
                    next('/monitor'); // 用 next 跳转，不要用 router.push
                } else {

                    Vue.prototype.$message({
                        message: res.data.msg,
                        type: 'error',
                        duration: 2000
                    });
                    next(); // 登录失败，继续走原路由逻辑
                }
            }

        } catch (err) {
            // 捕获网络错误/接口异常
            console.error('登录请求异常：', err);
            Vue.prototype.$message({
                message: '网络异常，登录请求失败',
                type: 'error',
                duration: 2000
            });
            next(); // 异常时也执行 next，避免路由卡住
        }
    } else {
        // 不满足条件时，正常执行 next
        next();
    }
});

export default router
